
































import WidgetMixins from '@/mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Getter } from 'vuex-class';

@Component({
  name: 'FileUpload',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class FileUpload extends mixins(WidgetMixins) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean; // button loading

  receipt: File | null = null;

  @Emit('save')
  action() {
    const formData = new FormData();
    formData.set('file', this.receipt as any, this.receipt?.name);
    return {
      loading: {
        idx: 'upload',
        state: false,
      },
      body: formData,
    };
  }

  @Emit('actions')
  onClose() {
    return { state: false, idx: 'upload' };
  }
}
